export enum IdpProvider {
  facebook = 'facebook',
  google = 'google'
}
